// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3O879","right":"styles_right__3qL0H"};